<template>
	<div class="spittoon-block">
		<div class="maincontent__double-header-wrapper spittoon-block__header">
			<div class="maincontent__double-header">
				<h2 class="maincontent__double-header-title">Wyposażenie bloku spluwaczki</h2>
				<h2 class="maincontent__double-header-unit unit-model-header">
					<small>Unit stomatologiczny</small>
					<br />
					{{ unit.fullName }}
				</h2>
			</div>
		</div>
		<div>
			<div class="spittoon-block__main">
				<h4 class="spittoon-block__lead">System ssący</h4>
				<small class="spittoon-block__description">Wybierz jedną opcję:</small>
				<div
					class="spittoon-block__radio-group"
					v-for="(item, i) in suctionSystemsHalf"
					:key="`sb-suction-${i}`"
				>
					<Radio
						class="spittoon-block__radio"
						name="suction-system"
						:value="suctionSystems[2 * i].name"
						@change="handleSuctionSystemChange"
						:checked="suctionSystems[2 * i].name === suctionSystem"
						:key="`control__${2 * i}`"
					>
						<span class="spittoon-block__radio-label">{{ suctionSystems[2 * i].fullName }}</span>
						<span @click.stop class="spittoon-block__radio-cost" slot="right-addon">
							<span>{{ formatPrice(suctionSystems[2 * i].cost) }}</span>
							<Tooltip
								v-if="suctionSystems[2 * i].tooltip_text"
								:text="suctionSystems[2 * i].tooltip_text"
							/>
						</span>
					</Radio>
					<Radio
						v-if="suctionSystems[2 * i + 1]"
						class="spittoon-block__radio"
						name="suction-system"
						:value="suctionSystems[2 * i + 1].name"
						@change="handleSuctionSystemChange"
						:checked="suctionSystems[2 * i + 1].name === suctionSystem"
						:key="`control__${2 * i + 1}`"
					>
						<span class="spittoon-block__radio-label">{{
							suctionSystems[2 * i + 1].fullName
						}}</span>
						<span @click.stop class="spittoon-block__radio-cost" slot="right-addon">
							<span>{{ formatPrice(suctionSystems[2 * i + 1].cost) }}</span>
							<Tooltip
								v-if="suctionSystems[2 * i + 1].tooltip_text"
								:text="suctionSystems[2 * i + 1].tooltip_text"
							/>
						</span>
					</Radio>
					<div v-else class="spittoon-block__radio radio"></div>
				</div>
			</div>
			<div v-if="waterSupplies.length > 0" class="spittoon-block__main">
				<h4 class="spittoon-block__lead">System zasilania wody</h4>
				<small class="spittoon-block__description">Możesz wybrać dowolną liczbę:</small>
				<div
					class="spittoon-block__tile-group"
					v-for="(item, i) in waterSuppliesHalf"
					:key="`sb-ws-${i}`"
				>
					<div
						:class="{
							'spittoon-block__tile': true,
							'spittoon-block__tile--active': supplies.includes(waterSupplies[2 * i].name),
						}"
						@click="handleSuppliesChange(waterSupplies[2 * i].name)"
					>
						<span
							:class="{
								'spittoon-block__cost': true,
								'spittoon-block__cost--tooltip': !!waterSupplies[2 * i].tooltip_text,
							}"
						>
							{{ formatPrice(waterSupplies[2 * i].cost) }}
							<Tooltip
								v-if="waterSupplies[2 * i].tooltip_text"
								:text="waterSupplies[2 * i].tooltip_text"
							/>
						</span>
						<div class="spittoon-block__tile-selection">
							<span
								:class="[
									'spittoon-block__tile-checkmark',
									{
										'--checkbox': canChooseMultipleWaterSupplies,
										'--checked': supplies.includes(waterSupplies[2 * i].name),
									},
								]"
							></span>
							{{ waterSupplies[2 * i].fullName }}
						</div>
						<img
							v-if="waterSupplies[2 * i].image"
							class="spittoon-block__image"
							:src="require(`@/assets/pictures/${waterSupplies[2 * i].image}`)"
						/>
					</div>
					<div
						v-if="waterSupplies[2 * i + 1]"
						:class="{
							'spittoon-block__tile': true,
							'spittoon-block__tile--active': supplies.includes(waterSupplies[2 * i + 1].name),
						}"
						@click="handleSuppliesChange(waterSupplies[2 * i + 1].name)"
					>
						<span
							:class="{
								'spittoon-block__cost': true,
								'spittoon-block__cost--tooltip': !!waterSupplies[2 * i + 1].tooltip_text,
							}"
						>
							{{ formatPrice(waterSupplies[2 * i + 1].cost) }}
							<Tooltip
								v-if="waterSupplies[2 * i + 1].tooltip_text"
								:text="waterSupplies[2 * i + 1].tooltip_text"
							/>
						</span>
						<div class="spittoon-block__tile-selection">
							<span
								:class="[
									'spittoon-block__tile-checkmark',
									{
										'--checkbox': canChooseMultipleWaterSupplies,
										'--checked': supplies.includes(waterSupplies[2 * i + 1].name),
									},
								]"
							></span>
							{{ waterSupplies[2 * i + 1].fullName }}
						</div>
						<img
							v-if="waterSupplies[2 * i + 1].image"
							class="spittoon-block__image"
							:src="require(`@/assets/pictures/${waterSupplies[2 * i + 1].image}`)"
						/>
					</div>
				</div>
			</div>
		</div>
		<div class="physician-table__right-side"></div>
	</div>
</template>

<script>
import * as R from 'ramda';
import SingleChoice from '../SingleChoice';
import AppDataMixin from '@/mixins/app-data';
import Radio from '../Radio';
import Tooltip from '../Tooltip';

export default {
	name: 'SpittoonBlock',
	mixins: [AppDataMixin],
	components: {Radio, Tooltip},
	data() {
		return {
			suctionSystems: [],
			waterSupplies: [],
			suctionSystemsHalf: [],
			waterSuppliesHalf: [],
		};
	},
	computed: {
		suctionSystem() {
			return this.$store.state.unitConfiguration.suctionSystem || '';
		},
		supplies() {
			return this.$store.state.unitConfiguration.waterSupplies || [];
		},
		canChooseMultipleWaterSupplies() {
			return true;
		},
	},
	mounted() {
		this.suctionSystems = this.getAppData('suctionSystemsList');
		this.suctionSystemsHalf = new Array(Math.round(this.suctionSystems.length / 2));
		this.waterSupplies = this.getAppData('waterSuppliesList');
		this.waterSuppliesHalf = new Array(Math.round(this.waterSupplies.length / 2));
	},
	methods: {
		handleSuctionSystemChange(selectedSuctionSystem) {
			if (selectedSuctionSystem !== null)
				this.$store.commit('unitConfiguration/setSuctionSystem', selectedSuctionSystem || null);
		},
		handleSuppliesChange(waterSupply) {
			const setOperator = this.canChooseMultipleWaterSupplies ? R.append : s => () => [s];

			const newWaterSupplies = this.supplies.includes(waterSupply)
				? R.without([waterSupply], this.supplies)
				: R.pipe(setOperator(waterSupply))(this.supplies);

			this.$store.commit('unitConfiguration/setWaterSupplies', newWaterSupplies);
		},
	},
};
</script>
